import React, { useEffect, useState } from 'react';
import useForm from "modules/forms/hooks/useForm";
import { Route, Routes } from "react-router-dom";
import useHttp from "components/hooks/useHttp";
import useToast from "components/hooks/useToast";
import CustomPage from "modules/forms/hosted/private/pages/CustomPage";
import CustomSuccess from "modules/forms/hosted/private/pages/CustomSuccess";
import Loader from "components/Loader";
import useRouting from "hooks/useRouting";
import useFormFlow from "modules/forms/hooks/useFormFlow";
import { isNullOrEmptyString } from "core/helpers";

export default function AuthenticatedRoutes() {
    const { form } = useForm();
    const { push } = useRouting();
    const http = useHttp();
    const { setValues, setContact } = useFormFlow();
    const { errorToast, successToast } = useToast();
    const [contactPending, setContactPending] = useState(false);
    const apiUrl = `/forms/${form.uuid}/private/authenticate-contact`;

    const mergeObjectsAndKeepValues = (currentValues: object, contactData: object) => {
        const result: Record<string, any> = {};

        const allKeys = new Set([...Object.keys(currentValues), ...Object.keys(contactData)]);

        allKeys.forEach(key => {
            const currentValue = (currentValues as Record<string, any>)[key];
            const contactValue = (contactData as Record<string, any>)[key];

            if (isNullOrEmptyString(contactValue)) {
                result[key] = currentValue;
            } else {
                result[key] = contactValue;
            }
        });

        return result;
    };

    useEffect(() => {
        const token = sessionStorage.getItem("token");

        if (!token) {
            push(`/forms/${form.uuid}/private/authenticate`);
            return;
        }

        setContactPending(true);
        http.get(apiUrl, {
            token: token,
        })
            .then(res => {
                const contactData = res.data.data;
                setContact(contactData);

                setValues(prevValues => {

                    // The server also withholds sending further contact data if prepopulates is set to false.
                    // But we do it here anyway, we do not merge in contact data if prepopulates is set to false.
                    if (form.prepopulates) {
                        return {
                            ...mergeObjectsAndKeepValues(prevValues, contactData.values),
                            email: contactData.email,
                        };
                    } else {
                        return {
                            ...prevValues,
                            email: contactData.email,
                        };
                    }
                });

                successToast(`Logged in as ${contactData.email}`);
            })
            .catch(e => {
                errorToast(e);
                console.log("Some err I think we need to delete token as well.");
            })
            .finally(() => setContactPending(false));
    }, []);

    if (contactPending) {
        return <Loader/>;
    }

    return (
        <Routes>
            <Route path={"/custom"} element={<CustomPage/>}/>
            <Route path={"/custom-success"} element={<CustomSuccess/>}/>
        </Routes>
    );
}